// src/Utils.js

/**
 * Derives passive abilities from a roster of acquired mentors.
 * @param {Object} roster - Map of mentor IDs.
 * @returns {Array} List of passive modifications.
 */
export function derivePassives(roster, equippedIds = []) {
  const passives = [];
  const mentorsDB = window.MENTORS_DB || [];
  
  if (!roster) return passives;

  equippedIds.forEach(id => {
    if (!id || !roster[id]) return;
    const mentorData = mentorsDB.find(m => m.id === id);
    if (mentorData) {
      passives.push({
        id: id,
        mentor: mentorData,
        level: roster[id].level || 1,
        affinity: roster[id].affinity || 0
      });
    }
  });
  return passives;
}

/**
 * Triggers a click sound.
 * @param {Object} audio - AudioManager instance.
 */
export function playClick(audio) {
    if (audio && audio.playClick) audio.playClick();
}
/**
 * Converts technical IDs (snake_case) to human-readable labels (Title Case).
 * Example: "ped_exantemas_var" -> "Exantemas Var"
 * @param {string} str 
 */
export function formatLabel(str) {
    if (!str || typeof str !== 'string') return str;
    
    // Remove technical prefixes like ped_, go_, etc.
    const clean = str.replace(/^(ped|go|sur|med|uro|der|ren|tra|neu|gas|end|inf)_/i, '');
    
    return clean
        .split('_')
        .map(word => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase())
        .join(' ');
}
